'use client';

import {TableOfContents} from '@utils/articles/tableOfContents';

import {Accordion} from '@web-landing/components/Accordion';

import styles from './ArticleTableOfContents.module.scss';

type Props = {
  title?: string;
  tableOfContents: TableOfContents;
  onAccordionClick?: () => void;
};

const defaultTitle = 'Содержание';

export default function ArticleTableOfContents({
  title,
  tableOfContents,
  onAccordionClick,
}: Props) {
  return (
    <>
      <Accordion
        classes={{
          root: styles.root,
          title: styles.root__title,
        }}
        onClick={onAccordionClick}
        title={<h2 className={styles.title}>{title || defaultTitle}</h2>}
        content={
          <ol className={styles.list}>
            {tableOfContents.entries.map(({anchor, title}) => (
              <li className={styles.listItem} key={anchor}>
                <a href={`#${anchor}`}>{title}</a>
              </li>
            ))}
          </ol>
        }
        opened={false}
      />
    </>
  );
}
